export class NotificationsFilterModel {
  public size: number;

  public page: number;

  constructor(data: Partial<NotificationsFilterModel> = {}) {
    this.size = data.size ?? 5;
    this.page = data.page ?? 0;
  }
}
